<template>
  <div class="staff">
    <Header v-bind:header="header"></Header>

    <v-container class="non_bg">
      <v-row
        class="justify-center justify-xl-end justify-lg-end justify-md-end"
      >
        <v-col :cols="12" xl="9" lg="9" md="9" sm="8">
          <QuoteTile v-bind:quoteSet="quoteSet"></QuoteTile>
        </v-col>
      </v-row>
    </v-container>

    <!-- <div class="notecontainer">
      <NoteCircle v-bind:config="noteCircle1"></NoteCircle>
    </div> -->

    <v-container class="light_bg top_space pb-10">
      <v-row wrap class="justify-center justify-md-end" mb-10>
        <v-col cols="10" xl="6" lg="6" md="6" sm="8">
          <RunningText v-bind:text="introText"></RunningText>
        </v-col>
      </v-row>
      <v-row
        class="justify-center justify-xl-start justify-lg-start justify-md-start"
      >
        <v-col :cols="12" xl="6" lg="6" md="6" sm="8">
          <VideoTile
            v-bind:video="video"
            class="overtile withShaddow"
          ></VideoTile>
        </v-col>
      </v-row>
    </v-container>

    <div class="pb-sm-16 pb-md-16 pb-lg-16 pb-xl-16">
      <v-container class="dark_bg top_space noverflow_ma">
        <div class="notecontainer">
          <NoteCircle v-bind:config="noteCircle1"></NoteCircle>
          <NoteCircle v-bind:config="noteCircle2"></NoteCircle>
        </div>
        <div>
          <Artist
            v-bind:artists="artists"
            v-bind:currentArtist="currentArtist"
          ></Artist>
        </div>
        <div class="no_verflow">
          <StaffCarousel
            v-bind:artists="artists"
            @clicked="onChangeArtist"
          ></StaffCarousel>
        </div>
      </v-container>
    </div>
  </div>
</template>


<script>
import Header from "./Header.vue";
import QuoteTile from "./QuoteTile.vue";
import VideoTile from "./VideoTile.vue";
import RunningText from "./RunningText.vue";
import Artist from "./Artist.vue";
import StaffCarousel from "./StaffCarousel.vue";
import NoteCircle from "./NoteCircle.vue";

export default {
  name: "Staff",
  components: {
    Header,
    QuoteTile,
    VideoTile,
    RunningText,
    Artist,
    StaffCarousel,
    NoteCircle,
  },
  computed: {
    getOrder() {
      const { smAndDown } = this.$vuetify.breakpoint;
      return smAndDown ? 1 : 12;
    },
    getOrder2() {
      const { smAndDown } = this.$vuetify.breakpoint;
      return smAndDown ? 12 : 1;
    },
  },
  methods: {
    onChangeArtist(value) {
      this.currentArtist = value;
      // console.log(this.currentArtist)
    },
  },
  data() {
    return {
      header: "Personal",
      noteCircle1: {
        id: "staff_c1",
        width: 350,
        top: 350,
        left: -200,
        style: "stroke-dasharray: 0.6;",
        strokeWidth: 6,
        transform:
          "translate(calc(calc(calc(var(--parallax-value) * 1.2px)) - 900px), calc(var(--parallax-value) * -0.5px)) rotateZ(calc(var(--parallax-value) * 0.7deg))",
        maxLimit: 1200,
        minLimit: 900,
      },
      noteCircle2: {
        id: "staff_c2",
        width: 350,
        top: 0,
        left: 0,
        style: "stroke-dasharray: 0.6;",
        strokeWidth: 6,
        transform:
          "translate(calc(calc(calc(var(--parallax-value) * -0.8px)) + 650px), calc(var(--parallax-value) * 0px)) rotateZ(calc(var(--parallax-value) * 0.7deg))",
        minLimit: 900,
        maxLimit: 1700,
      },
      video: {
        id: "vid2",
        url: "/staff/Snippet.mp4",
        poster: "/staff/poster.png",
      },
      quoteSet: {
        withImage: true,
        img: {
          url: "/intro/scene_NY.jpeg",
          alt: "Szene New York",
        },
        quotes: [
          {
            id: 1,
            quoteLines: [
              {
                id: 1,
                text:
                  "Hier hat alles gestimmt. Gutes Konzept, tolle Band, schöne Evergreen-Auswahl - alles vom Feinsten. Chapeau!",
              },
            ],
            author: "Christian Maintz (Autor)",
          },
          {
            id: 2,
            quoteLines: [
              {
                id: 1,
                text:
                  "Noch mal vielen Dank für den bejazzten Konzertabend. Das hat große Freude gemacht, die ganzen Nummern zu hören. Ich mag auch Spain und Birdland so doll gerne.",
              },
            ],
            author: "Zuschauer-Stimme",
          },
        ],
      },
      introText:
        "<p>JAZZTERDAYS vereint einige der besten Jazzmusiker Norddeutschlands, die meisten mit internationale Erfahrungen. Musical Director ist Bassist Arnd Geise. Sängerin San Glaser ist Mittelpunkt des Abends – mit ihren Versionen von berührenden und vitalen Jazzstandards wie „Strange Fruit“ oder „My Baby Just Cares for me“.</p>",
      currentArtist: 0,
      artists: [
        {
          id: 1,
          name: "San Glaser",
          bio:
            "studierte Musik & Jazzgesang in den Niederlanden. Sie zog nach Deutschland, sammelte Erfahrungen von Trio bis Big Band und bei der Formation Jazzkantine. Ab 2005 produziert sie Alben unter eigenem Namen (zuletzt „The Great Grand Hotel“) und bewegt sich stilistisch virtuos zwischen Folk, Soul und Jazz.",
          img: "/staff/SanGlaser_320P.png",
          thumbnailImg: "/staff/SanGlaser_320.png",
          thumbnailAlt: "San Glaser am Mikrofon",
        },
        {
          id: 2,
          name: "Sascha Rotermund",
          bio:
            "ist Stammgast auf deutschen Bühnen und regelmäßig in TV zu sehen. Der Schauspieler, Sprecher und Sänger zählt zu den gefragtesten Synchronsprechern Deutschlands. Er lieh u.a. Benedict Cumberbatch und Omar Sy („Ziemlich beste Freunde“) seine Stimme.",
          img: "/staff/Sascha Rotermund_320P.png",
          thumbnailImg: "/staff/Sascha Rotermund_320.png",
          thumbnailAlt: "Sascha Rotermund",
        },
        {
          id: 3,
          name: "Hans-Jörg Frey",
          bio:
            "war Ensemblemitglied im Hamburger Schauspielhaus und im Thalia Theater. Der Schweizer Schauspieler und Wahlhamburger spielte u.a. mit Iris Berben und Axel Milberg und tourt mit einem eigenen Kabarett-Programm.",
          img: "/staff/HansJorgFrey_320P.png",
          thumbnailImg: "/staff/HansJorgFrey_320.png",
          thumbnailAlt: "Hans Jörg Frey am Mikrofon",
        },
        {
          id: 4,
          name: "Volker Präkelt",
          bio:
            "arbeitet für TV, Hörspiel, Buch und Musik und wurde mit Preisen wie dem Jahrespreis der Deutschen Schallplattenkritik oder dem ARD-Hörspielpreis ausgezeichnet. Er macht Hörspiele, Filme und Filmmusik für den NDR und schreibt Bücher.",
          img: "/staff/VolkerPraekelt_320P.png",
          thumbnailImg: "/staff/VolkerPraekelt_320.png",
          thumbnailAlt: "",
        },
        {
          id: 5,
          name: "Arnd Geise",
          bio:
            "ist ein international agierender Bassist. Neben der San Glaser Band spielt er im Joel Havea Trio, mit dem Sänger Jeff Cascaro oder dem Gitarristen Barry Finnerty (ex-Miles Davis).",
          img: "/staff/ArndGeise_320P.png",
          thumbnailImg: "/staff/ArndGeise_320.png",
          thumbnailAlt: "",
        },
        {
          id: 6,
          name: "Mischa Schumann",
          bio:
            "ist eine feste Größe in der Hamburger Szene. Neben den Aktivitäten in seinen eigenen Gruppen („Schumannize“) spielt er auch immer wieder in der NDR Big Band.",
          img: "/staff/MischaSchumann_320P.png",
          thumbnailImg: "/staff/MischaSchumann_320.png",
          thumbnailAlt: "",
        },
        {
          id: 7,
          name: "Ralph Reichert",
          bio:
            "stellte sein herausragendes Saxophonspiel in den Dienst von Musikern wie Curtis Fuller oder  Brian Melvin und veröffentlichte Tonträger unter eigenem Namen. Er ist eng verbunden mit dem Hamburger Birdland, das jahrzehntelang von seinem Vater betrieben wurde.",
          img: "/staff/RalphReichert_320P.png",
          thumbnailImg: "/staff/RalphReichert_320.png",
          thumbnailAlt: "",
        },
        {
          id: 8,
          name: "Johannes Wennrich",
          bio:
            "lebt und arbeitet als Gitarrist in Hamburg. Als gefragter Studio- und Live-Musiker arbeitete er mit Anna Depenbusch, Yvonne Catterfeldt, Reinhold Beckmann und San Glaser.",
          img: "/staff/JohannesWennrich_320P.png",
          thumbnailImg: "/staff/JohannesWennrich_320.png",
          thumbnailAlt: "",
        },
        {
          id: 9,
          name: "Henrik Wehnert",
          bio:
            "studierte Jazzgitarre am Konservatorium in Hilversum. Er tritt u.a. mit der Gruppe JazzRed auf und bereichert mit seinem exquisiten Gitarrenspiel auch die San Glaser Band.",
          img: "/staff/HenrikWehnert_320P.png",
          thumbnailImg: "/staff/HenrikWehnert_320.png",
          thumbnailAlt: "",
        },
        {
          id: 10,
          name: "Tobias Held",
          bio:
            "ist Chef seines eigenen „Indie Jazz Projekts“. Der Schlagzeuger, der in Arnheim und Hamburg studiert hat,  begleitete u.a. Max Mutzke, Johannes Oerding, Sasha, Tom Gäbel und Roger Cicero.",
          img: "/staff/TobiasHeld_320P.png",
          thumbnailImg: "/staff/TobiasHeld_320.png",
          thumbnailAlt: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.no_verflow {
  overflow: hidden;
  position: relative;
  bottom: -37px;
  margin-bottom: -200px;
}
.noverflow_ma {
  margin-bottom: 200px;
  padding-right: 0px;
  padding-left: 0px;
}

.overtile {
  position: relative;
  bottom: -130px;
  overflow: overlay;
  margin-top: -130px;
}

.withShaddow {
  box-shadow: -26px 29px 13px -6px rgba(0, 0, 0, 0.6);
}

.notecontainer {
  position: relative;
}
</style>